import { render, staticRenderFns } from "./AkbsSubTaskPanel.vue?vue&type=template&id=c0476abc&scoped=true&"
import script from "./AkbsSubTaskPanel.vue?vue&type=script&lang=js&"
export * from "./AkbsSubTaskPanel.vue?vue&type=script&lang=js&"
import style0 from "./AkbsSubTaskPanel.vue?vue&type=style&index=0&id=c0476abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0476abc",
  null
  
)

export default component.exports